import * as types from 'constants/ActionTypes';

/**
 * Update the carousel session state for a given trip segment.
 * Should be dispatched on every carousel interaction (scroll or day selection).
 *
 * @param {string} way - Trip segment: 'departure' or 'return'.
 * @param {object} payload - Interaction data.
 * @param {string} payload.originalSearchDate - Date the user arrived at search with (YYYY-MM-DD).
 * @param {string|null} [payload.dateSelected] - Newly selected date (only on day select).
 * @param {number|null} [payload.dateDelta] - Days delta vs original search date (only on day select).
 * @returns {object} Redux action.
 */
export function setCarouselSession(way, payload) {
  return { type: types.SET_CAROUSEL_SESSION, way, payload };
}

/**
 * Reset the carousel session state for all trip segments.
 * Should be dispatched when the user initiates a new search.
 * @returns {object} Redux action.
 */
export function resetCarouselSession() {
  return { type: types.RESET_CAROUSEL_SESSION };
}

export default setCarouselSession;
